import { inject, Injectable } from '@angular/core';
import {
  CheckAppointmentHistoryResponse,
  CheckIfRegisteredRequest,
  CheckIfRegisteredResponse,
  LoginRequest,
  LoginResponse,
  LoginSendOtpRequest,
  LoginSendOtpResponse,
  LoginValidateOtpRequest,
  LoginValidateOtpResponse,
  CheckEnterpriseAvailableTimeRequest,
  CheckEnterpriseAvailableTimeResponse
} from '../interfaces/login-register.model';
import { API_ENDPOINTS } from '../constants/api.constants';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '../interfaces/api-response.model';

/**
 * 登入註冊服務
 */
@Injectable({
  providedIn: 'root',
})
export class LoginRegisterService {
  http: HttpClient = inject(HttpClient);

  /**
   * 會員登入驗證，同步查詢密碼設定是否 >180 天
   * @param idNumber 身分證字號
   * @param password 密碼
   */
  login(
    idNumber: string,
    password: string
  ): Observable<ApiResponse<LoginResponse>> {
    const payload: LoginRequest = {
      idNo: idNumber,
      password: password,
    };

    return this.http.post<ApiResponse<LoginResponse>>(
      API_ENDPOINTS.LOGIN,
      payload
    );
  }

  /**
   * 發送/重新發送 OTP 驗證碼至手機/信箱
   * @param idNumber 身分證字號
   * @param channel 發送管道（cell/email）
   */
  loginSendOtp(
    idNumber: string,
    channel: string
  ): Observable<ApiResponse<LoginSendOtpResponse>> {
    const payload: LoginSendOtpRequest = {
      idNo: idNumber,
      channel: channel,
    };

    return this.http.post<ApiResponse<LoginSendOtpResponse>>(
      API_ENDPOINTS.LOGIN_SEND_OTP,
      payload
    );
  }

  /**
   * 驗證 OTP 驗證碼
   * @param idNumber 身分證字號
   * @param otp OTP驗證碼
   */
  loginValidateOtp(
    idNumber: string,
    otp: string
  ): Observable<ApiResponse<LoginValidateOtpResponse>> {
    const payload: LoginValidateOtpRequest = {
      idNo: idNumber,
      otp: otp,
    };

    return this.http.post<ApiResponse<LoginValidateOtpResponse>>(
      API_ENDPOINTS.LOGIN_VALIDATE_OTP,
      payload
    );
  }

  /**
   * 查詢該身分證字號是否為已註冊為會員
   * @param idNumber 身分證字號
   * @param birthDay 生日(YYYYMMDD)
   */
  checkIfRegistered(
    idNumber: string,
  ): Observable<ApiResponse<CheckIfRegisteredResponse>> {
    const payload: CheckIfRegisteredRequest = {
      idNo: idNumber,
    };

    return this.http.post<ApiResponse<CheckIfRegisteredResponse>>(
      API_ENDPOINTS.CHECK_IF_REGISTERED,
      payload
    );
  }

  checkAppointmentHistory(
    idNo: string,
    birthday: string
  ): Observable<ApiResponse<CheckAppointmentHistoryResponse>> {
    const payload = { idNo, birthday };

    return this.http.post<ApiResponse<CheckAppointmentHistoryResponse>>(
      API_ENDPOINTS.APPOINTMENT_HISTORY,
      payload
    );
  }

  /*
   * CB-039 查詢企業預約資料狀態
   * @param companyNo 企業代碼
   * @param employeeId 員工編號
   * @param idNo 身分證字號
   * @param familyFlag 身分別（1：員工本人 2：員工眷屬）
   */
  checkEnterpriseAvailableTime(
    companyNo: string,
    employeeId: string,
    idNo: string,
    familyFlag: string
  ): Observable<ApiResponse<CheckEnterpriseAvailableTimeResponse>> {
    const payload: CheckEnterpriseAvailableTimeRequest = {
      companyNo: companyNo,
      employeeId: employeeId,
      idNo: idNo,
      familyFlag: familyFlag,
    };
    return this.http.post<ApiResponse<CheckEnterpriseAvailableTimeResponse>>(
      API_ENDPOINTS.CHECK_ENTERPRISE_AVAILABLE_TIME,
      payload
    );
  }
}
